import { useCallback, useMemo } from 'react';

import { DcrDisplayStatus } from '@/core/graphql/generated/types';
import { useQueryParams } from '@/utils/url/useQueryParams';

import type { StatusFilterValue } from '../StatusFilter/StatusFilter';

const VALID_DCR_STATUSES = new Set<string>([
	DcrDisplayStatus.ChangePendingreview,
	DcrDisplayStatus.ChangeRejected,
	DcrDisplayStatus.ChangePartial,
	DcrDisplayStatus.ChangeAccepted
]);

export const validateDcrStatuses = (values: string[]): StatusFilterValue[] =>
	values.filter((v): v is StatusFilterValue => VALID_DCR_STATUSES.has(v));

export const useDcrQueryParams = () => {
	const { dcrSearch, dcrStatus, page, setQueryParams } = useQueryParams();

	const dcrStatuses = useMemo(
		() => validateDcrStatuses(dcrStatus),
		[dcrStatus]
	);

	const setDcrSearch = useCallback(
		(value: string) => {
			setQueryParams({ dcrSearch: value, page: undefined }, { replace: true });
		},
		[setQueryParams]
	);

	const setDcrStatuses = useCallback(
		(values: StatusFilterValue[]) => {
			setQueryParams({ dcrStatus: values, page: undefined }, { replace: true });
		},
		[setQueryParams]
	);

	const setDcrPage = useCallback(
		(newPage: number) => {
			setQueryParams({ page: newPage > 1 ? newPage : undefined });
		},
		[setQueryParams]
	);

	return {
		dcrSearch,
		dcrStatuses,
		dcrPage: page,
		setDcrSearch,
		setDcrStatuses,
		setDcrPage
	};
};
